import { LastTermDistribution } from "@oldDashboard/legacyModels/lastTermDistribution.model";
import { LastTermDistributionSerializer } from "@oldDashboard/legacyModels/serializers/lastTermDistributionSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";

export class CommandLastTermDistribution {
    async run(launchSelected: String, timePeriodSelected: String) {  
        const path = `get-chart-data/client:last-term-distribution/?launch_id=${launchSelected}&time_period=${timePeriodSelected}`
        try {
            const response = await legacyReportingGet(path);
            if(response.success)
                return this.deserialize(response.chart_data);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : LastTermDistribution{
        const serializer = new LastTermDistributionSerializer();
        return serializer.deserialize(data);
    }
}

